import { XMarkIcon } from '@heroicons/react/16/solid';
import { Button, Collapse, Loading, Modal } from 'react-daisyui';
import { useModalsContext } from '../../../../../providers/ModalsProvider/Modals.context.ts';
import { useChatContext } from '../../../Chat.hook.ts';
import { tLeadStages } from '../../../Chat.types.ts';
import useChatMenu from '../../ChatMenu/ChatMenu.hook.ts';

export default function FunnelModal(): JSX.Element {
  const {
    funnelsWithStages,
    loading,
    selectedChat,
    setLoading,
    setUpdateChatEventsData,
    setNewFunnelID,
  } = useChatContext();
  const { handleUpdateStage } = useChatMenu();
  const { changeFunnelModalIsOpen, setChangeFunnelModalIsOpen } =
    useModalsContext();
  const { setSelectedLeadForChatModal, selectedLeadForChatModal } =
    useModalsContext();

  async function onClickSelectNewStage(stage: tLeadStages, funnelId: string) {
    setLoading(true);

    await handleUpdateStage(stage, funnelId);

    setNewFunnelID(funnelId);

    if (!selectedChat?.lead) return;

    setSelectedLeadForChatModal(
      selectedLeadForChatModal
        ? {
            ...selectedLeadForChatModal,
            funnel: {
              uuid: funnelId,
              name: stage.name || '',
              isDefault: false,
            },
          }
        : null,
    );
    setUpdateChatEventsData((prev) => prev + 1);
    setChangeFunnelModalIsOpen(!changeFunnelModalIsOpen);
    setLoading(false);
  }

  return (
    <Modal
      open={changeFunnelModalIsOpen}
      className="ChatMenu__FunnelModal"
      backdrop={true}
      responsive={true}
    >
      <Modal.Header className="ChatMenu__FunnelModal__Header">
        <h1>Enviar a otro embudo</h1>
        <XMarkIcon
          onClick={() => {
            setChangeFunnelModalIsOpen(!changeFunnelModalIsOpen);
          }}
          className="ChatMenu__FunnelModal__CloseIcon"
        />
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="LeadInfo__Info__Funnel__Loader">
            <Loading size="lg" color="primary" />
          </div>
        ) : (
          <div className="flex flex-col justify-center">
            {funnelsWithStages?.map((funnel) => {
              return (
                <div key={funnel.id} className="relative w-80 mx-auto">
                  <Collapse
                    icon={'arrow'}
                    className="LeadInfo__Info__Collapse"
                    checkbox
                  >
                    <Collapse.Title className="LeadInfo__Info__Collapse__Title">
                      <p>{funnel.name}</p>
                    </Collapse.Title>
                    <Collapse.Content className="LeadInfo__Info__Collapse__Content">
                      {funnel.stages?.map((stage) => {
                        return (
                          <Button
                            key={stage.id}
                            color="neutral"
                            variant="outline"
                            size="sm"
                            onClick={() => {
                              onClickSelectNewStage(stage, funnel.id);
                            }}
                          >
                            {stage.name}
                          </Button>
                        );
                      })}
                    </Collapse.Content>
                  </Collapse>
                </div>
              );
            })}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
